<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  id?: string
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <p :id="props.id" data-slot="field-description" :class="cn('text-xs text-secondary', props.class)">
    <slot />
  </p>
</template>
